import React, { Component } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import { observer } from "mobx-react";
import { toJS } from "mobx";
import { CommonStore } from "../Store";
import { WarningOutlined } from "@mui/icons-material";

export default observer(class NetworkIndicator extends Component {
    static propTypes = {
        isStatus: PropTypes.string,
        isSmall: PropTypes.bool
    };
    static defaultProps = {
        isStatus: "online",
        isSmall: false
    };
    render() {
        const isOnline = toJS(CommonStore.isOnline)
        return !isOnline && <Wrapper>
            <IconWrapper><WarningOutlined /></IconWrapper>
            <Text>Reconnecting..</Text>
        </Wrapper>
    }
})

const IconWrapper = styled.div`
    padding: 5px;
`

const Text = styled.div`
    position: absolute;
    bottom: 5px;
    left: 30px;
`

const Wrapper = styled.div`
    width: 100%;
    height: 30px;
    font-size: 15px;
    display: flex;
    position: relative;
    background-color: #ffcc00;
    color: #6b798d;
`